//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { DataProvider } from '../helpers/data-provider'
import { TypeHelper } from '../helpers/type-helper'
import { Dictionary } from '../helpers/dictionary'

import { Enums } from '../models/common'
import { IReferenceType } from '../models/util/interfaces'

// #region CORE
import {
    OpAction, OpActionType, OpActionStatus, OpActivity, OpActor, OpActorGroup, OpAlarmDef, OpAlarmGroup, OpAlarmStatus, OpAlarmType, OpArticle,
    OpCommandCodeType, OpConfigurationProfile, OpConsumer, OpConsumerTransaction, OpConsumerType, OpDataType, OpDataTypeClass, OpDataTypeFormat,
    OpDataTypeGroup, OpDataTypeInGroup, OpDataFormatGroupDetails, OpDepositoryElement, OpDevice, OpDistributor, OpDistributorHierarchy,
    OpDescr, OpDeviceOrderNumber, OpDeviceType, OpDeviceStateType, OpLocation, OpFile, OpImrServer, OpIssue, OpIssueStatus, OpIssueType, OpLanguage, OpLocationEquipment,
    OpLocationType, OpLocationStateType, OpMeter, OpMeterType, OpMeterTypeClass, OpModule, OpMobileNetworkCode, OpOperator,
    OpProductCode, OpProfile, OpPriority, OpProtocol, OpReferenceType, OpRoute, OpRouteStatus, OpRouteType, OpRole, OpSimCard,
    OpSlotType, OpTariff, OpTask, OpTaskGroup, OpTaskStatus, OpTaskType, OpTechnicalPermission, OpTransmissionType, OpUnit, OpView, OpOperatorGroup,
    OpPackageStatus, OpSupplier, OpTaskTypeGroup

} from '../models/core'

// #endregion

// #region Custom

import { OpEnumObject } from '../models/custom/op-enum-object'
import { OpReferenceTypeObject, ColumnInfo } from '../models/custom'

// #endregion

// #region DW

import { OpReport, OpReportType, OpAlarm, OpAlarmEvent, OpDeviceConnection } from '../models/dw'
import { OpPackage } from '../models/core/op-package'

// #endregion

// #region Private Types

type IReferenceTypeFactoryFunction = (obj: any) => IReferenceType

type IReferenceFactoryEntry = {
    constructor: { new(obj): IReferenceType },
    restoreMethod: (obj: any) => IReferenceType
}

// key - IdReferenceType, Value - tablica zależnych IdReferencceType
type IReferenceHierarchyFactoryEntry = {
    dependands: number[],
    orderNbr: number
}

// #endregion

export class ReferenceTypeComponent {
    // #region Consts

    private static get LOG_STRING(): string { return '[SIMAX.ReferenceTypeComponent] %s' }

    // #endregion

    // #region Members

    private static referenceObjectOperationTable: {
        [key: number]: IReferenceTypeFactoryFunction | IReferenceFactoryEntry
    } = {}

    private static referenceObjectHierarchyTable: {
        [key: number]: IReferenceHierarchyFactoryEntry
    } = {}

    // #endregion

    public static generateReferenceObjectMethodTable() {
        // #region CORE

        this.referenceObjectOperationTable[Enums.ReferenceType.ActionType] = { constructor: OpActionType, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdAction] = { constructor: OpAction, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdActionStatus] = { constructor: OpActionStatus, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdActivity] = { constructor: OpActivity, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdActor] = { constructor: OpActor, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdAlarmDef] = { constructor: OpAlarmDef, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdActorGroup] = { constructor: OpActorGroup, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdAlarmGroup] = { constructor: OpAlarmGroup, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdAlarmStatus] = { constructor: OpAlarmStatus, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdAlarmType] = { constructor: OpAlarmType, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdArticle] = { constructor: OpArticle, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdCommandCodeType] = { constructor: OpCommandCodeType, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdConfigurationProfile] = { constructor: OpConfigurationProfile, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdConsumer] = { constructor: OpConsumer, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdConsumerTransaction] = { constructor: OpConsumerTransaction, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdConsumerType] = { constructor: OpConsumerType, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdDataType] = { constructor: OpDataType, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdDataTypeClass] = { constructor: OpDataTypeClass, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdDataTypeFormat] = { constructor: OpDataTypeFormat, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdDataTypeGroup] = { constructor: OpDataTypeGroup, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdDataTypeInGroup] = { constructor: OpDataTypeInGroup, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdDataFormatGroupDetails] = { constructor: OpDataFormatGroupDetails, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdDistributor] = { constructor: OpDistributor, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdDistributorHierarchy] = { constructor: OpDistributorHierarchy, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdDeviceOrderNumber] = { constructor: OpDeviceOrderNumber, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdDeviceType] = { constructor: OpDeviceType, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdDeviceStateType] = { constructor: OpDeviceStateType, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdDepositoryElement] = { constructor: OpDepositoryElement, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdFile] = { constructor: OpFile, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdIMRServer] = { constructor: OpImrServer, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdIssue] = { constructor: OpIssue, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdIssueStatus] = { constructor: OpIssueStatus, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdIssueType] = { constructor: OpIssueType, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdLanguage] = { constructor: OpLanguage, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdLocation] = { constructor: OpLocation, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdLocationEquipment] = { constructor: OpLocationEquipment, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdLocationType] = { constructor: OpLocationType, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdLocationStateType] = { constructor: OpLocationStateType, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdMeter] = { constructor: OpMeter, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdMeterType] = { constructor: OpMeterType, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdMeterTypeClass] = { constructor: OpMeterTypeClass, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdModule] = { constructor: OpModule, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdMobileNetworkCode] = { constructor: OpMobileNetworkCode, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdOperator] = { constructor: OpOperator, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdOperatorGroup] = { constructor: OpOperatorGroup, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdProductCode] = { constructor: OpProductCode, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdProfile] = { constructor: OpProfile, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdPriority] = { constructor: OpPriority, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdProtocol] = { constructor: OpProtocol, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdReferenceType] = { constructor: OpReferenceType, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdReport] = { constructor: OpReport, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdRoute] = { constructor: OpRoute, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdRouteStatus] = { constructor: OpRouteStatus, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdRouteType] = { constructor: OpRouteType, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdRole] = { constructor: OpRole, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdReportType] = { constructor: OpReportType, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdSimCard] = { constructor: OpSimCard, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdSlotType] = { constructor: OpSlotType, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdSupplier] = { constructor: OpSupplier, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdTariff] = { constructor: OpTariff, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdTask] = { constructor: OpTask, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdTaskGroup] = { constructor: OpTaskGroup, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdTaskStatus] = { constructor: OpTaskStatus, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdTaskType] = { constructor: OpTaskType, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdTaskTypeGroup] = { constructor: OpTaskTypeGroup, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdTechnicalPermission] = { constructor: OpTechnicalPermission, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdTransmissionType] = { constructor: OpTransmissionType, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdUnit] = { constructor: OpUnit, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdView] = { constructor: OpView, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.SerialNbr] = { constructor: OpDevice, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdPackage] = { constructor: OpPackage, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdPackageStatus] = { constructor: OpPackageStatus, restoreMethod: null }

        // #endregion

        // #region Custom

        this.referenceObjectOperationTable[Enums.ReferenceType.IdDeviceUdiDescription] = (obj: any) => new OpReferenceTypeObject(obj, OpDescr)
        this.referenceObjectOperationTable[Enums.ReferenceType.IdLocationFieldElement] = (obj: any) => new OpReferenceTypeObject(obj, OpDescr)
        this.referenceObjectOperationTable[Enums.ReferenceType.IdLocationInstallationCategory] = (obj: any) => new OpReferenceTypeObject(obj, OpDescr)
        this.referenceObjectOperationTable[Enums.ReferenceType.IdLocationProjectType] = (obj: any) => new OpReferenceTypeObject(obj, OpDescr)
        this.referenceObjectOperationTable[Enums.ReferenceType.IdMeterAcoChangeoverPressureRegulatorType] = (obj: any) => new OpReferenceTypeObject(obj, OpDescr)
        this.referenceObjectOperationTable[Enums.ReferenceType.IdUIObjectProperties] = { constructor: OpEnumObject, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdUniversalDigitalInputConfiguration] = { constructor: OpEnumObject, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.Month] = { constructor: OpEnumObject, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.SSRSRenderFormat] = { constructor: OpEnumObject, restoreMethod: null }
        // #endregion

        // #region DW

        this.referenceObjectOperationTable[Enums.ReferenceType.IdAlarm] = { constructor: OpAlarm, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdAlarmEvent] = { constructor: OpAlarmEvent, restoreMethod: null }
        this.referenceObjectOperationTable[Enums.ReferenceType.IdDeviceConnection] = { constructor: OpDeviceConnection, restoreMethod: null }

        // #endregion
    }

    public static generateReferenceObjectHierarchyTable() {
        let orderNbr: number = 0
        this.referenceObjectHierarchyTable[Enums.ReferenceType.IdDataTypeClass] = { dependands: [], orderNbr: orderNbr++ }
        this.referenceObjectHierarchyTable[Enums.ReferenceType.IdReferenceType] = { dependands: [], orderNbr: orderNbr++ }
        this.referenceObjectHierarchyTable[Enums.ReferenceType.IdUnit] = { dependands: [], orderNbr: orderNbr++ }
        this.referenceObjectHierarchyTable[Enums.ReferenceType.IdDataTypeFormat] = { dependands: [], orderNbr: orderNbr++ }
        this.referenceObjectHierarchyTable[Enums.ReferenceType.IdDataType] = { dependands: [Enums.ReferenceType.IdDataTypeClass, Enums.ReferenceType.IdReferenceType, Enums.ReferenceType.IdDataTypeFormat, Enums.ReferenceType.IdUnit], orderNbr: orderNbr++ }
        this.referenceObjectHierarchyTable[Enums.ReferenceType.IdDataTypeGroup] = { dependands: [Enums.ReferenceType.IdReferenceType], orderNbr: orderNbr++ }
        this.referenceObjectHierarchyTable[Enums.ReferenceType.IdDataTypeInGroup] = { dependands: [Enums.ReferenceType.IdDataType, Enums.ReferenceType.IdDataTypeGroup], orderNbr: orderNbr++ }
        this.referenceObjectHierarchyTable[Enums.ReferenceType.None] = { dependands: [], orderNbr: orderNbr++ }
    }

    public static createReferenceObject(referenceType: Enums.ReferenceType, referenceObject: any): IReferenceType {
        if (!referenceObject) {
            return null
        }

        const factory: IReferenceTypeFactoryFunction | IReferenceFactoryEntry = this.referenceObjectOperationTable[referenceType]

        if (factory == null) {
            console.warn(ReferenceTypeComponent.LOG_STRING, `Unsupported reference object creation. IdReferenceType: ${referenceType}. ReferenceType: ${Enums.ReferenceType[referenceType]}`)

            return null
        }

        if (TypeHelper.isFunction<IReferenceTypeFactoryFunction>(factory)) {
            return factory(referenceObject)
        }
        else {
            return new factory.constructor(referenceObject)
        }
    }

    public static restoreReferenceObject(referenceType: Enums.ReferenceType, referenceObject: any): IReferenceType {
        if (!referenceObject) {
            return null
        }

        const factory: IReferenceTypeFactoryFunction | IReferenceFactoryEntry = this.referenceObjectOperationTable[referenceType]

        if (factory == null || TypeHelper.isFunction(factory)) {
            console.warn(ReferenceTypeComponent.LOG_STRING, `Unsupported reference object restore. IdReferenceType: ${referenceType}. ReferenceType: ${Enums.ReferenceType[referenceType]}`)

            return null
        }
        else {
            const factoryEntry: IReferenceFactoryEntry = factory as IReferenceFactoryEntry

            if (factoryEntry.restoreMethod != null) {
                return factoryEntry.restoreMethod(referenceObject)
            }
        }
    }

    public static getReferenceObject(dataProvider: DataProvider, referenceType: Enums.ReferenceType, referenceObjectId: number): JQueryPromise<IReferenceType> {
        switch (referenceType) {
            case Enums.ReferenceType.IdActor:
                return dataProvider.Actor.getActor(referenceObjectId)
            case Enums.ReferenceType.IdAlarmGroup:
                return dataProvider.AlarmGroup.getAlarmGroup(referenceObjectId)
            case Enums.ReferenceType.IdConsumer:
                return dataProvider.Consumer.getConsumer(referenceObjectId)
            case Enums.ReferenceType.IdConsumerType:
                return dataProvider.ConsumerType.getConsumerType(referenceObjectId)
            case Enums.ReferenceType.IdDepositoryElement:
                return dataProvider.Location.getLocation(referenceObjectId).toPromise()
            case Enums.ReferenceType.IdDistributor:
                return dataProvider.Distributor.getDistributor(referenceObjectId)
            case Enums.ReferenceType.IdIssueType:
                return ReferenceTypeComponent.getDictionaryReferenceObject(dataProvider, referenceType, referenceObjectId)
            case Enums.ReferenceType.IdLocation:
                return dataProvider.Location.getLocation(referenceObjectId).toPromise()
            case Enums.ReferenceType.IdMeter:
                return dataProvider.Meter.getMeter(referenceObjectId).toPromise()
            case Enums.ReferenceType.IdReport:
                return dataProvider.Report.getReport(referenceObjectId)
            case Enums.ReferenceType.IdRoute:
                return dataProvider.Route.getRoute(referenceObjectId)
            case Enums.ReferenceType.IdOperator:
                return dataProvider.Operator.getOperator(referenceObjectId)
            case Enums.ReferenceType.IdOperatorGroup:
                return dataProvider.OperatorGroup.getOperatorGroup(referenceObjectId)
            case Enums.ReferenceType.IdProductCode:
                return ReferenceTypeComponent.getDictionaryReferenceObject(dataProvider, referenceType, referenceObjectId)
            case Enums.ReferenceType.IdSimCard:
                return dataProvider.SimCard.getSimCard(referenceObjectId)
            case Enums.ReferenceType.IdTariff:
                return dataProvider.Tariff.getTariff(referenceObjectId)
            case Enums.ReferenceType.IdTask:
                return dataProvider.Task.getTask(referenceObjectId).toPromise()
            case Enums.ReferenceType.IdTaskType:
                return dataProvider.TaskType.getTaskType(referenceObjectId)
            case Enums.ReferenceType.IdIssue:
                return dataProvider.Issue.getIssue(referenceObjectId)
            case Enums.ReferenceType.SerialNbr:
                return dataProvider.Device.getDevice(referenceObjectId).toPromise()
            case Enums.ReferenceType.IdPackage:
                return dataProvider.Order.getOrder(referenceObjectId)
            case Enums.ReferenceType.IdSupplier:
                return dataProvider.Supplier.getSupplier(referenceObjectId).toPromise()
            default:
                console.log("getReferenceObject Unsupported reference type:" + Enums.ReferenceType[referenceType])
                return null
        }
    }

    public static getDictionaryReferenceObject(dataProvider: DataProvider, referenceType: Enums.ReferenceType, referenceObjectId: number): JQueryPromise<IReferenceType> {
        return dataProvider
            .System
            .getDictionaries([referenceType])
            .then((dicts: Dictionary<Dictionary<IReferenceType>>) => {
                const referenceObjectDict: Dictionary<IReferenceType> = dicts.tryGetValue(referenceType)

                return referenceObjectDict != null
                    ? referenceObjectDict.tryGetValue(referenceObjectId)
                    : null
            })
    }

    public static loadReferenceObjectNavigationProperties(dataProvider: DataProvider, referenceType: Enums.ReferenceType, referenceObjects: any[]): JQueryPromise<any[]> {
        if (referenceObjects && referenceObjects.length > 0) {
            switch (referenceType) {
                case Enums.ReferenceType.ActionType:
                    return OpActionType.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdActionStatus:
                    return OpActionStatus.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdActivity:
                    return OpActivity.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdActor:
                    return OpActor.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdAlarmGroup:
                    return OpAlarmGroup.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdAlarmType:
                    return OpAlarmType.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdAlarmStatus:
                    return OpAlarmStatus.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdConsumer:
                    return OpConsumer.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdConfigurationProfile:
                    return OpConfigurationProfile.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdDataFormatGroupDetails:
                    return OpDataFormatGroupDetails.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdDataType:
                    return OpDataType.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdDataTypeClass:
                    return OpDataTypeClass.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdDataTypeFormat:
                    return OpDataTypeFormat.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdDataTypeGroup:
                    return OpDataTypeGroup.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdDataTypeInGroup:
                    return OpDataTypeInGroup.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdDeviceType:
                    return OpDeviceType.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdDeviceStateType:
                    return OpDeviceStateType.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdDeviceConnection:
                    return OpDeviceConnection.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdDistributor:
                    return OpDistributor.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdDistributorHierarchy:
                    return OpDistributorHierarchy.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdIssueStatus:
                    return OpIssueStatus.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdIssueType:
                    return OpIssueType.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdIMRServer:
                    return OpImrServer.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdMeter:
                    return OpMeter.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdMeterType:
                    return OpMeterType.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdMeterTypeClass:
                    return OpMeterTypeClass.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdModule:
                    return OpModule.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdLanguage:
                    return OpLanguage.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdLocation:
                    return OpLocation.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdLocationType:
                    return OpLocationType.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdLocationStateType:
                    return OpLocationStateType.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdOperator:
                    return OpOperator.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdProfile:
                    return OpProfile.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdProductCode:
                    return OpProductCode.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdPriority:
                    return OpPriority.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdProtocol:
                    return OpProtocol.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdReferenceType:
                    return OpReferenceType.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdReport:
                    return OpReport.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdReportType:
                    return OpReportType.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdRole:
                    return OpRole.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdRoute:
                    return OpRoute.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdRouteType:
                    return OpRouteType.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdRouteStatus:
                    return OpRouteStatus.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdSimCard:
                    return OpSimCard.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdSlotType:
                    return OpSlotType.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdTaskType:
                    return OpTaskType.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdTaskStatus:
                    return OpTaskStatus.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdTransmissionType:
                    return OpTransmissionType.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdUnit:
                    return OpUnit.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.SerialNbr:
                    return OpDevice.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdPackage:
                    return OpPackage.loadNavigationProperties(dataProvider, referenceObjects)
                case Enums.ReferenceType.IdPackageStatus:
                    return OpPackageStatus.loadNavigationProperties(dataProvider, referenceObjects)
                default:
                    console.log("Unsupported reference object navigation properties load. Reference object type: " + Enums.ReferenceType[referenceType])
                    break;
            }
        }
        return $.Deferred<any[]>().resolve(referenceObjects).promise()
    }

    public static getFilterItemsByWebSimaxModule(dataProvider: DataProvider, module: Enums.WebSimaxModule, columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string): any {
        switch (module) {
            case Enums.WebSimaxModule.Actions:
                return dataProvider.Action.getActionFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.Actors:
                return dataProvider.Actor.getActorFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.AlarmGroups:
                return dataProvider.AlarmGroup.getAlarmGroupFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.AlarmEvents:
                return dataProvider.AlarmEvent.getAlarmEventFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.ConsumerTypes:
                return dataProvider.ConsumerType.getConsumerTypeFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.Consumers:
                return dataProvider.Consumer.getConsumerFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.Depositories:
                return dataProvider.Depository.getDepositoryFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.DeviceConnections:
                return dataProvider.DeviceConnection.getDeviceConnectionFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.Devices:
                return dataProvider.Device.getDeviceFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.Distributors:
                return dataProvider.Distributor.getDistributorFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.GroupingLocations:
                return dataProvider.GroupingLocation.getGroupingLocationFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.GroupingLocationsTypes:
                return dataProvider.GroupingLocationType.getGroupingLocationTypesFilter()
            case Enums.WebSimaxModule.Issues:
                return dataProvider.Issue.getIssueFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.Locations:
                return dataProvider.Location.getLocationFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.Meters:
                return dataProvider.Meter.getMeterFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.OperatorGroups:
                return dataProvider.OperatorGroup.getOperatorGroupFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.Operators:
                return dataProvider.Operator.getOperatorFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.Orders:
                return dataProvider.Order.getOrderFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.Packages:
                return dataProvider.Package.getPackageFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.Reports:
                return dataProvider.Report.getReportFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.Routes:
                return dataProvider.Route.getRouteFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.SimCards:
                return dataProvider.SimCard.getSimCardFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.Tariffs:
                return dataProvider.Tariff.getTariffFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.Tasks:
                return dataProvider.Task.getTaskFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.WebSimaxModule.TasksTypes:
                return dataProvider.TaskType.getTaskTypeFilter(columns, pageNbr, pageSize, customWhereClause)
            default:
                console.log("No filter items for given websimax module: " + Enums.WebSimaxModule[module])
                return null
        }
    }

    public static getFilterItemsByReferenceType(dataProvider: DataProvider, referenceType: Enums.ReferenceType, columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string): any {
        switch (referenceType) {
            case Enums.ReferenceType.IdAction:
                return dataProvider.Action.getActionFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.ReferenceType.IdActor:
                return dataProvider.Actor.getActorFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.ReferenceType.IdAlarmEvent:
                return dataProvider.AlarmEvent.getAlarmEventFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.ReferenceType.IdAlarmGroup:
                return dataProvider.AlarmGroup.getAlarmGroupFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.ReferenceType.IdConsumer:
                return dataProvider.Consumer.getConsumerFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.ReferenceType.IdConsumerType:
                return dataProvider.ConsumerType.getConsumerTypeFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.ReferenceType.IdDeviceConnection:
                return dataProvider.DeviceConnection.getDeviceConnectionFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.ReferenceType.IdDistributor:
                return dataProvider.Distributor.getDistributorFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.ReferenceType.IdIssue:
                return dataProvider.Issue.getIssueFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.ReferenceType.IdLocation:
                return dataProvider.Location.getLocationFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.ReferenceType.IdReport:
                return dataProvider.Report.getReportFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.ReferenceType.IdSimCard:
                return dataProvider.SimCard.getSimCardFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.ReferenceType.IdOperator:
                return dataProvider.Operator.getOperatorFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.ReferenceType.IdTariff:
                return dataProvider.Tariff.getTariffFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.ReferenceType.IdOperatorGroup:
                return dataProvider.OperatorGroup.getOperatorGroupFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.ReferenceType.IdTask:
                return dataProvider.Task.getTaskFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.ReferenceType.IdTaskType:
                return dataProvider.TaskType.getTaskTypeFilter(columns, pageNbr, pageSize, customWhereClause)
            case Enums.ReferenceType.SerialNbr:
                return dataProvider.Device.getDeviceFilter(columns, pageNbr, pageSize, customWhereClause)
            default:
                return dataProvider.System.getReferenceObjectList(referenceType, [], columns, pageNbr, pageSize, customWhereClause, null)
        }
    }

    public static getModuleByReferenceType(idReference: Enums.ReferenceType): Enums.SimaxModuleName {
        switch (idReference) {
            case Enums.ReferenceType.IdAction:
                return Enums.SimaxModuleName.Action
            case Enums.ReferenceType.IdActor:
                return Enums.SimaxModuleName.Actor
            case Enums.ReferenceType.IdAlarmEvent:
                return Enums.SimaxModuleName.Alarm
            case Enums.ReferenceType.IdAlarmGroup:
                return Enums.SimaxModuleName.Alarm_Group
            case Enums.ReferenceType.IdConsumer:
                return Enums.SimaxModuleName.Consumer
            case Enums.ReferenceType.IdConsumerType:
                return Enums.SimaxModuleName.Consumer_Type
            case Enums.ReferenceType.SerialNbr:
                return Enums.SimaxModuleName.Device
            case Enums.ReferenceType.IdDeviceConnection:
                return Enums.SimaxModuleName.Device_Connection
            case Enums.ReferenceType.IdDistributor:
                return Enums.SimaxModuleName.Distributor
            case Enums.ReferenceType.IdLocationType:
                return Enums.SimaxModuleName.Grouping_Location_Type
            case Enums.ReferenceType.IdIssue:
                return Enums.SimaxModuleName.Issue
            case Enums.ReferenceType.IdLocation:
                return Enums.SimaxModuleName.Location
            case Enums.ReferenceType.IdMeter:
                return Enums.SimaxModuleName.Meter
            case Enums.ReferenceType.IdOperator:
                return Enums.SimaxModuleName.Operator
            case Enums.ReferenceType.IdOperatorGroup:
                return Enums.SimaxModuleName.Operator_Group
            case Enums.ReferenceType.IdReport:
                return Enums.SimaxModuleName.Report
            case Enums.ReferenceType.IdRoute:
                return Enums.SimaxModuleName.Route
            case Enums.ReferenceType.IdSimCard:
                return Enums.SimaxModuleName.Sim_Card
            case Enums.ReferenceType.IdTariff:
                return Enums.SimaxModuleName.Tariff
            case Enums.ReferenceType.IdTask:
                return Enums.SimaxModuleName.Task
            case Enums.ReferenceType.IdTaskType:
                return Enums.SimaxModuleName.Task_Type

            default:
                console.log("Module name not found by idReference: " + Enums.SimaxModuleName[idReference])
                return Enums.SimaxModuleName.Unknown
        }
    }

    public static getReferenceTypeByModule(moduleName: Enums.SimaxModuleName): Enums.ReferenceType {
        switch (moduleName) {
            case Enums.SimaxModuleName.Action:
                return Enums.ReferenceType.IdAction
            case Enums.SimaxModuleName.Actor:
                return Enums.ReferenceType.IdActor
            case Enums.SimaxModuleName.Alarm:
                return Enums.ReferenceType.IdAlarmEvent
            case Enums.SimaxModuleName.Alarm_Group:
                return Enums.ReferenceType.IdAlarmGroup
            case Enums.SimaxModuleName.Consumer:
                return Enums.ReferenceType.IdConsumer
            case Enums.SimaxModuleName.Consumer_Type:
                return Enums.ReferenceType.IdConsumerType
            case Enums.SimaxModuleName.Depository:
                return Enums.ReferenceType.IdLocation
            case Enums.SimaxModuleName.Device:
                return Enums.ReferenceType.SerialNbr
            case Enums.SimaxModuleName.Device_Connection:
                return Enums.ReferenceType.IdDeviceConnection
            case Enums.SimaxModuleName.Distributor:
                return Enums.ReferenceType.IdDistributor
            case Enums.SimaxModuleName.Grouping_Location:
                return Enums.ReferenceType.IdLocation
            case Enums.SimaxModuleName.Grouping_Location_Type:
                return Enums.ReferenceType.IdLocationType
            case Enums.SimaxModuleName.Issue:
                return Enums.ReferenceType.IdIssue
            case Enums.SimaxModuleName.Location:
                return Enums.ReferenceType.IdLocation
            case Enums.SimaxModuleName.Meter:
                return Enums.ReferenceType.IdMeter
            case Enums.SimaxModuleName.Operator:
                return Enums.ReferenceType.IdOperator
            case Enums.SimaxModuleName.Operator_Group:
                return Enums.ReferenceType.IdOperatorGroup
            case Enums.SimaxModuleName.Report:
                return Enums.ReferenceType.IdReport
            case Enums.SimaxModuleName.Route:
                return Enums.ReferenceType.IdRoute
            case Enums.SimaxModuleName.Sim_Card:
                return Enums.ReferenceType.IdSimCard
            case Enums.SimaxModuleName.Supplier:
                return Enums.ReferenceType.IdSupplier
            case Enums.SimaxModuleName.Tariff:
                return Enums.ReferenceType.IdTariff
            case Enums.SimaxModuleName.Task:
                return Enums.ReferenceType.IdTask
            case Enums.SimaxModuleName.Task_Type:
                return Enums.ReferenceType.IdTaskType
            case Enums.SimaxModuleName.Order:
                return Enums.ReferenceType.IdPackage
            case Enums.SimaxModuleName.Package:
                return Enums.ReferenceType.IdPackage
            default:
                console.log("Reference type not found for module: " + Enums.SimaxModuleName[moduleName])
                return Enums.ReferenceType.None
        }
    }

    public static getDependandReferenceObjectTypes(referenceType: Enums.ReferenceType, dependandReferenceObjectTypes: Enums.ReferenceType[] = null): Enums.ReferenceType[] {
        if (!dependandReferenceObjectTypes)
            dependandReferenceObjectTypes = []
        if (this.referenceObjectHierarchyTable[referenceType]) {
            for (var _i = 0; _i < this.referenceObjectHierarchyTable[referenceType].dependands.length; _i++) {
                ReferenceTypeComponent.getDependandReferenceObjectTypes(this.referenceObjectHierarchyTable[referenceType].dependands[_i], dependandReferenceObjectTypes)
                if (!dependandReferenceObjectTypes[this.referenceObjectHierarchyTable[referenceType].dependands[_i]])
                    dependandReferenceObjectTypes.push(this.referenceObjectHierarchyTable[referenceType].dependands[_i])
            }
        }
        return dependandReferenceObjectTypes
    }
    public static orderReferenceObjectTypeByHierarchy(referenceTypes: Enums.ReferenceType[]): Enums.ReferenceType[] {
        var result: Enums.ReferenceType[] = []
        if (!referenceTypes)
            return referenceTypes

        for (var _i = 0; _i < referenceTypes.length; _i++) {
            var minReferenceType: Enums.ReferenceType = Enums.ReferenceType.None
            var unsupportedReferenceType: Enums.ReferenceType = Enums.ReferenceType.None
            for (var _j = 0; _j < referenceTypes.length; _j++) {
                if (!result.some(d => d == referenceTypes[_j])) {
                    if (!this.referenceObjectHierarchyTable[referenceTypes[_j]]) {
                        unsupportedReferenceType = referenceTypes[_j]//jeżeli nie zdefiniowany w tabeli to wstawiamy do docelowej listy na samym końcu
                    }
                    else if (this.referenceObjectHierarchyTable[minReferenceType].orderNbr >= this.referenceObjectHierarchyTable[referenceTypes[_j]].orderNbr)
                        minReferenceType = referenceTypes[_j]
                }
            }
            if (minReferenceType == Enums.ReferenceType.None) {
                if (unsupportedReferenceType != Enums.ReferenceType.None)
                    result.push(unsupportedReferenceType)
            }
            else
                result.push(minReferenceType)
        }
        return result
    }
}

ReferenceTypeComponent.generateReferenceObjectMethodTable()
ReferenceTypeComponent.generateReferenceObjectHierarchyTable()
